// Session odometer: turns GPS fixes into metres travelled. Only ever adds.
// Case GPS (25 Hz) wins over phone GPS while it has sent a fix in the last 2 s.
// Gaps (jump > max step) are skipped: the anchor moves, no metres are added.
import { calculateDistance } from '../hooks/useGPS';

const SPEED_FLOOR_MPS = 0.3;
const MAX_STEP_M = { phone: 100, case: 50 };
const CASE_PRIORITY_MS = 2000;

export function createOdometer() {
  let anchor = null;
  let lastCaseT = 0;

  function push({ lat, lng, speed, source, t = Date.now() }) {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return 0;
    if (source === 'case') lastCaseT = t;
    else if (lastCaseT && t - lastCaseT < CASE_PRIORITY_MS) return 0;
    const prev = anchor;
    anchor = { lat, lng, source };
    if (!prev || prev.source !== source) return 0;
    const d = calculateDistance(prev.lat, prev.lng, lat, lng);
    const moving = typeof speed === 'number' ? speed >= SPEED_FLOOR_MPS : true;
    return d < MAX_STEP_M[source] && moving ? d : 0;
  }

  return { push, reset() { anchor = null; lastCaseT = 0; } };
}
